<template>
  <v-layout>
    <v-flex xs12>
    <v-card class="mt-2" width="100%">
      <v-card-title>
      <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition" :overlay="false">
        <v-btn color="primary" dark slot="activator" class="mb-2">New template</v-btn>
        <v-card>
          <v-toolbar dark color="primary">
          <v-btn icon @click.native="close" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{formTitle}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat dark @click.native="save" :disabled="!newTemplateValid">Save</v-btn>
        </v-toolbar>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                <v-tabs icons-and-text centered color="grey lighten-4">
                <v-tabs-slider color="yellow"></v-tabs-slider>
                <v-tab href="#tab-1">
                  Options
                  <v-icon>settings_applications</v-icon>
                </v-tab>
                <!-- <v-tab href="#tab-2">
                  Items
                  <v-icon>assignment</v-icon>
                </v-tab> -->
                <v-tab href="#tab-3">
                  Sales Info
                  <v-icon>mdi-playlist-edit</v-icon>
                </v-tab>
                <v-tab-item value="tab-1" class="pa-2">
                  <v-form ref="newTemplate" v-model="newTemplateValid">
                  <v-text-field 
                    label="Template Name" 
                    v-model="editedItem.name"
                    :rules="[v => !!v || 'Name is required']" 
                    required>
                  </v-text-field>
                  <v-select 
                    label="Parent Product" 
                    v-model="editedItem.parent"
                    :items="parentProducts"
                    :rules="[v => !!v || 'Name is required']" 
                    required>
                  </v-select>
                  <v-select
                    label="Devices Required"
                    v-model="editedItem.devices"
                    :items="deviceTypes"
                    chips
                    deletable-chips
                    multiple
                  >
                  </v-select>
                  <v-checkbox 
                    label="Hidden (used to hide old products)"
                    v-model="editedItem.hidden"
                  />
                  </v-form>
                </v-tab-item>
                <v-tab-item value="tab-2" class="pa-2">
                <v-card>
                  <v-card-title>
                    Add New Item
                  </v-card-title>
                  <v-card-text>
                  <v-text-field v-model="newTemplateItem.title"
                  label="Item Title">
                  </v-text-field>
                  <v-text-field v-model="newTemplateItem.text"
                  label="Item Text">
                  </v-text-field>
                  <v-checkbox label="Optional" v-model="newTemplateItem.optional"></v-checkbox>
                  <v-checkbox label="Image" v-model="newTemplateItem.photo"></v-checkbox>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn color="primary" @click="addNewTemplateItem()" v-if="editItemIndex === -1">Add</v-btn>
                      <v-btn color="primary" @click="addNewTemplateItem()" v-else>Edit</v-btn>
                      <v-btn @click="cancelItem()" v-if="editItemIndex !== -1">Cancel</v-btn>
                    </v-card-actions>
                  </v-card>
                  <v-list three-line avatar>
                    <template v-for="(item, index) in editedItem.items">
                    <v-divider v-if="index > 0"></v-divider>
                    <v-subheader v-else>Template Items</v-subheader>
                    <v-list-tile :key="index">
                      <v-list-tile-action>
                        <v-btn v-if="index > 0" icon class="mx-0" @click.stop="moveTemplateItemUp(index)">
                          <v-icon color="primary">keyboard_arrow_up</v-icon>
                        </v-btn>
                        <v-spacer v-if="index < 1 || index >= editedItem.items.length -1"></v-spacer>
                        <v-btn v-if="index < editedItem.items.length -1" icon class="mx-0" @click.stop="moveTemplateItemDown(index)">
                          <v-icon color="primary">keyboard_arrow_down</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                      <v-list-tile-avatar>
                        <v-icon icon v-html="item.photo ? 'add_a_photo' : 'description'"></v-icon>
                        <v-icon icon v-html="item.optional ? '': 'visibility'"></v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>{{item.title}}</v-list-tile-title>
                        <v-list-tile-sub-title v-html="item.text"></v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon class="mx-0" @click="newTemplateItem = JSON.parse(JSON.stringify(editedItem.items[index])); editItemIndex = index">
                          <v-icon color="teal">edit</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                      <v-list-tile-action>
                        <v-btn icon class="mx-0" @click="editedItem.items.splice(index, 1)">
                          <v-icon color="pink">delete</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>
                    </template>
                  </v-list>
                  </v-tab-item>
                <v-tab-item value="tab-3" class="pa-2">
                <v-card>
                  <v-card-title>
                    Add New Sales Item
                  </v-card-title>
                  <v-card-text>
                  <v-combobox 
                    v-model="newTemplateExtra.name"
                    label="Item Title"
                    :items="extrasList"
                  >
                  </v-combobox>
                  <v-text-field label="Default" v-model="newTemplateExtra.default"></v-text-field>
                  <v-select 
                    v-model="newTemplateExtra.type"
                    label="Item Type"
                    :items="['choice', 'text', 'number']"
                  >
                  </v-select>
                  <v-text-field v-if="newTemplateExtra.type == 'number'" label="Step" v-model="newTemplateExtra.step" type="number"></v-text-field>
                  <v-combobox
                    v-if="newTemplateExtra.type == 'choice'" 
                    v-model="newTemplateExtra.options"
                    label="Item Options"
                    multiple
                    chips
                    deletable-chips
                  >
                  </v-combobox>
                  <v-checkbox label="Required" v-model="newTemplateExtra.required"></v-checkbox>
                  <v-select 
                    v-model="newTemplateExtra.permissions.customer"
                    label="Customer Permissions"
                    :items="['none', 'read', 'write']"
                  >
                  </v-select>
                  <v-select 
                    v-model="newTemplateExtra.permissions.sales"
                    label="Sales Permissions"
                    :items="['none', 'read', 'write']"
                  >
                  </v-select>
                  <v-select 
                    v-model="newTemplateExtra.permissions.support"
                    label="Support Permissions"
                    :items="['none', 'read', 'write']"
                  >
                  </v-select>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn color="primary" @click="addNewTemplateExtra()" v-if="editExtraIndex === -1">Add</v-btn>
                      <v-btn color="primary" @click="addNewTemplateExtra()" v-else>Edit</v-btn>
                      <v-btn @click="cancelExtra()" v-if="editExtraIndex !== -1">Cancel</v-btn>
                    </v-card-actions>
                  </v-card>
                  <v-list three-line avatar>
                    <template v-for="(item, index) in editedItem.extras">
                    <v-divider v-if="index > 0"></v-divider>
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-btn v-if="index > 0" icon class="mx-0" @click.stop="moveExtraUp(index)">
                          <v-icon color="primary">keyboard_arrow_up</v-icon>
                        </v-btn>
                        <v-spacer v-if="index < 1 || index >= editedItem.extras.length -1"></v-spacer>
                        <v-btn v-if="index < editedItem.extras.length -1" icon class="mx-0" @click.stop="moveExtraDown(index)">
                          <v-icon color="primary">keyboard_arrow_down</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{item.name}}</v-list-tile-title>
                        <v-list-tile-sub-title v-html="item.type"></v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon class="mx-0" @click="newTemplateExtra = JSON.parse(JSON.stringify(editedItem.extras[index])); editExtraIndex = index">
                          <v-icon color="teal">edit</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                      <v-list-tile-action>
                        <v-btn icon class="mx-0" @click="editedItem.extras.splice(index, 1)">
                          <v-icon color="pink">delete</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>
                    </template>
                  </v-list>
                  </v-tab-item>
                  </v-tabs>
                </v-flex>
              </v-layout>
            </v-container>
        </v-card>
      </v-dialog>
        <v-spacer></v-spacer>
      </v-card-title>
        <v-list>
          <template v-for="(item, i) in templates">
          <v-list-tile avatar :key="i">
            <v-list-tile-action>
              <v-btn v-if="i > 0" icon class="mx-0" @click.stop="moveItemUp(item)">
                <v-icon color="primary">keyboard_arrow_up</v-icon>
              </v-btn>
              <v-spacer v-if="i < 1 || i >= templates.length -1"></v-spacer>
              <v-btn v-if="i < templates.length -1" icon class="mx-0" @click.stop="moveItemDown(item)">
                <v-icon color="primary">keyboard_arrow_down</v-icon>
              </v-btn>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title v-text="item.name"></v-list-tile-title>
            </v-list-tile-content>
              <!-- <v-list-tile-action>
              <v-text-field @change="saveIndex($event, item)" v-model="item.Index" style="width: 50px;"></v-text-field>
              </v-list-tile-action> -->
              <v-list-tile-action>
                <v-btn icon class="mx-0" @click.stop="editItem(item)">
                  <v-icon color="teal">edit</v-icon>
                </v-btn>
              </v-list-tile-action>
              <!-- <v-list-tile-action>
                <v-btn icon class="mx-0" @click.stop="deleteItem(item)">
                  <v-icon color="pink">delete</v-icon>
                </v-btn>
              </v-list-tile-action> -->
            </v-list-tile>
            <v-divider></v-divider>
            </template>
        </v-list>
    </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { fireStore } from '../../firebase'
export default {
  data () {
    return {
      expanded: false,
      newTemplateValid: false,
      deviceTypes: [],
      parentProducts: [],
      editExtraIndex: -1,
      editItemIndex: -1,
      newTemplateItem: {
        text: '',
        title: '',
        Index: 0,
        photo: true,
        optional: false
      },
      newTemplateExtra: {
        name: '',
        options: [],
        Index: 0,
        step: 0.01,
        type: 'text',
        permissions: {
          customer: 'none',
          sales: 'write',
          support: 'write'
        },
        optional: false
      },
      headers: [
        {
          text: 'Name',
          value: 'name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Order',
          value: 'Index',
          align: 'left'
        },
        {
          text: 'Actions',
          value: 'Actions',
          align: 'right',
          sortable: false
        }
      ],
      search: '',
      dialog: false,
      editedIndex: -1,
      engineers: [],
      tableLoading: false,
      editedItem: {
        name: '',
        Index: 0,
        devices: [],
        parent: null,
        items: [],
        extras: [],
        hidden: false
      },
      defaultItem: {
        name: '',
        Index: 0,
        devices: [],
        parent: null,
        items: [],
        extras: [],
        hidden: false
      }
    }
  },
  created () {
    this.tableLoading = true
    this.$store.dispatch('fetchProductTypes')
    // fireStore.collection('productType').orderBy('Index').get()
    // .then(snap => {
    //   snap.forEach(doc => {
    //     let data = doc.data()
    //     data.id = doc.id
    //     this.templates.push(data)
    //     this.tableLoading = false
    //   })
    // })
    fireStore.collection('parentProducts').orderBy('name').get()
    .then(snap => {
      snap.forEach(doc => {
        let data = {}
        data.value = doc.id
        data.text = doc.data().name
        this.parentProducts.push(data)
      })
    })
    fireStore.collection('deviceType').orderBy('Index').get()
    .then(snap => {
      snap.forEach(doc => {
        let data = {}
        data.value = doc.id
        data.text = doc.data().name
        this.deviceTypes.push(data)
      })
    })
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New template' : 'Edit template'
    },
    extrasList () {
      let extrasList = []
      for (let template of this.templates) {
        if (template.extras !== undefined) {
          for (let extra of template.extras) {
            if (extrasList.indexOf(extra.name) === -1) {
              extrasList.push(extra.name)
            }
          }
        }
      }
      return extrasList
    },
    templates () {
      return this.$store.getters.productTypes
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  methods: {
    saveIndex (val, item) {
      fireStore.collection('productType').doc(item.id).set({Index: parseInt(val)}, {merge: true})
    },
    addNewTemplateItem () {
      if (this.editItemIndex === -1) {
        this.editedItem.items.push(this.newTemplateItem)
      } else {
        this.editedItem.items[this.editItemIndex] = this.newTemplateItem
      }
      this.editItemIndex = -1
      this.newTemplateItem = {
        text: '',
        title: '',
        photo: true,
        optional: false
      }
    },
    addNewTemplateExtra () {
      if (this.editExtraIndex === -1) {
        this.editedItem.extras.push(this.newTemplateExtra)
      } else {
        this.editedItem.extras[this.editExtraIndex] = this.newTemplateExtra
      }
      this.editExtraIndex = -1
      this.newTemplateExtra = {
        name: '',
        options: [],
        Index: 0,
        step: 0.01,
        type: 'text',
        permissions: {
          customer: 'none',
          sales: 'read',
          support: 'write'
        },
        default: '',
        optional: false
      }
    },
    cancelExtra () {
      this.editExtraIndex = -1
      this.newTemplateExtra = {
        name: '',
        options: [],
        Index: 0,
        step: 0.01,
        type: 'text',
        permissions: {
          customer: 'none',
          sales: 'read',
          support: 'write'
        },
        optional: false
      }
    },
    cancelItem () {
      this.editItemIndex = -1
      this.newTemplateItem = {
        text: '',
        title: '',
        photo: true,
        optional: false
      }
    },
    moveItemUp (item) {
      let templates = [...this.templates]
      let index = templates.indexOf(item)
      let x = templates[index]
      templates[index] = templates[index - 1]
      templates[index - 1] = x
      templates[index - 1].Index = index - 1
      templates[index].Index = index
      // this.templates = templates
      fireStore.collection('productType').doc(templates[index].id).set(templates[index], {merge: true})
      fireStore.collection('productType').doc(templates[index - 1].id).set(templates[index - 1], {merge: true})
    },
    moveItemDown (item) {
      let templates = [...this.templates]
      let index = templates.indexOf(item)
      let x = templates[index]
      templates[index] = templates[index + 1]
      templates[index + 1] = x
      templates[index + 1].Index = index + 1
      templates[index].Index = index
      // this.templates = templates
      fireStore.collection('productType').doc(templates[index].id).set(templates[index], {merge: true})
      fireStore.collection('productType').doc(templates[index + 1].id).set(templates[index + 1], {merge: true})
    },
    moveExtraDown (index) {
      let temp = this.editedItem.extras[index]
      this.editedItem.extras[index] = this.editedItem.extras[index + 1]
      this.editedItem.extras[index + 1] = temp
      this.$forceUpdate()
    },
    moveExtraUp (index) {
      let temp = this.editedItem.extras[index]
      this.editedItem.extras[index] = this.editedItem.extras[index - 1]
      this.editedItem.extras[index - 1] = temp
      this.$forceUpdate()
    },
    moveTemplateItemDown (index) {
      let temp = this.editedItem.items[index]
      this.editedItem.items[index] = this.editedItem.items[index + 1]
      this.editedItem.items[index + 1] = temp
      this.$forceUpdate()
    },
    moveTemplateItemUp (index) {
      let temp = this.editedItem.items[index]
      this.editedItem.items[index] = this.editedItem.items[index - 1]
      this.editedItem.items[index - 1] = temp
      this.$forceUpdate()
    },
    editItem (item) {
      this.editedIndex = this.templates.indexOf(item)
      this.editedItem = {...this.defaultItem, ...item}
      this.editedItem.Index = this.editedItem.Index || this.editedIndex + 1
      this.dialog = true
    },

    deleteItem (item) {
      confirm('Are you sure you want to delete this item?') && fireStore.collection('productType').doc(item.id).delete()
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {
        fireStore.collection('productType').doc(this.editedItem.id).set(this.editedItem, {merge: true})
        .then(() => {
          this.close()
        })
      } else {
        this.editedItem.Index = this.templates.length + 1
        fireStore.collection('productType').add(this.editedItem)
        .then((docRef) => {
          this.close()
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Product.vue?6b4a55aa